<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th>
          <span jhiTranslate="LABEL.POSITION">Position</span>
        </th>
        <th>
          <span jhiTranslate="LABEL.ITEMS_NATURE">ItemsNature</span>
        </th>
        <th>
          <span jhiTranslate="LABEL.MAX_VALUE">maxValue</span>
        </th>
        <th>
          <span jhiTranslate="LABEL.INSURANCE_BASE_PRICE">basePricing</span>
        </th>
        <th>
          <span jhiTranslate="LABEL.INSURANCE_PRICING_RATE">pricingRate</span>
        </th>
        <th>
          <span jhiTranslate="LABEL.INSURANCE_RATE">insuranceRate</span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let insuranceItem of insuranceItems; trackBy: trackId; let index = index">
        <td>{{ insuranceItem.position }}</td>
        <td>
          <span class="no-capitalize" [mdbTooltip]="insuranceItem.itemsNature">{{ insuranceItem.itemsNature }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.maxValue | currency: 'EUR' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.basePricing | currency: 'EUR' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.pricingRate | number: '1.2-2' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.insuranceRate | number: '1.2-2' }}</span>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <jhi-bary-button
              class="mr-3"
              icon="pencil-alt"
              size="sm"
              color="primary"
              [tooltip]="'BTN.EDIT' | translate"
              [floating]="true"
              [outline]="true"
              [rounded]="true"
              (clickEvent)="edit(insuranceItem)"
            ></jhi-bary-button>
            <jhi-bary-button icon="times" size="sm" color="primary" [tooltip]="'BTN.DELETE' | translate" [floating]="true" [rounded]="true" (clickEvent)="delete(insuranceItem)">
            </jhi-bary-button>
          </div>
        </td>
      </tr>
      <tr *ngIf="!isHidden()" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="LABEL.NO_RESULT">No InsuranceItem</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
